module.exports = __webpack_public_path__ + "img/client-nwa.af212dd0.png";